import { render, staticRenderFns } from "./EditorField.vue?vue&type=template&id=c4f7a760&"
import script from "./EditorField.vue?vue&type=script&lang=js&"
export * from "./EditorField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports